import { render, staticRenderFns } from "./RegisterOnboarding.vue?vue&type=template&id=c6e0e35e&scoped=true"
import script from "./RegisterOnboarding.vue?vue&type=script&lang=js"
export * from "./RegisterOnboarding.vue?vue&type=script&lang=js"
import style0 from "./RegisterOnboarding.vue?vue&type=style&index=0&id=c6e0e35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e0e35e",
  null
  
)

export default component.exports